import { Grid, styled, Theme } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';

const $gutter = 25;

export const MainContainer = styled('div')({
  minHeight: 600,
});

export const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const FlexColumn = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const TwoColumn = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 50%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter}px)`,
});

export const Label = styled(Typography)<Theme, { $withButton?: boolean }>(({ $withButton }) => ({
  position: 'relative',
  borderBottom: '1px solid #2d343e',
  alignItems: 'center',
  paddingBottom: 15,
  margin: '10px 0',

  display: $withButton ? 'flex' : 'initial',
  justifyContent: $withButton ? 'space-between' : 'initial',

  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const ChipsContainer = styled('div')({
  marginTop: 10,

  '& .MuiChip-label': {
    marginTop: 2,
  },

  '& .MuiChip-root': {
    margin: '0 15px 10px 0',
    background: '#151b24',
    borderRadius: 8,
    height: 36,
  },

  '& svg': {
    marginLeft: 15,
  },
});
